import { PartnerRegistrationStore } from "@state/stores/membership/partner-registration";
import { useContext, createContext } from "react";

export const PartnerRegistrationStoreContext = createContext(
	{} as PartnerRegistrationStore
);

export const usePartnerRegistrationStore = () => {
	return useContext(PartnerRegistrationStoreContext);
};
